import Vue from 'vue'

import {
  Notification,
  Carousel,
  CarouselItem,
  Form,
  FormItem,
  Input,
  Button,
  Empty,
  Dialog,
  MessageBox,
  Select,
  Option,
  Rate,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Loading,
  avatar,
  table,
  tableColumn,
  Row,
  Col,
  Pagination,
  Message,
  Backtop,
  Icon,
  autocomplete
} from 'element-ui'

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Empty)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Rate)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Loading)
Vue.use(avatar)
Vue.use(table)
Vue.use(tableColumn)
Vue.use(Row)
Vue.use(Col)
Vue.use(Pagination)
Vue.use(Backtop)
Vue.use(Icon)
Vue.use(autocomplete)

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message